import { GlobalSearch } from "@/layout/GlobalSearch";
import { PageHeader } from "@/layout/PageHeader";
import { Page } from "@/layout/Page";

/** The mobile search screen: the same universal search, full width. */
export function SearchPage() {
  return (
    <Page width="reading">
      <PageHeader
        title="Recherche"
        subtitle="Un produit, un emplacement, un contenant — par nom, code ou code-barres."
      />
      <GlobalSearch autoFocus />
      <p className="mt-4 text-[13px] text-ink-subtle">
        Essayez un numéro de pièce, un code d'emplacement comme <code className="font-mono">BAC-67</code>,
        ou le nom d'un fabricant.
      </p>
    </Page>
  );
}
